export default defineAppConfig({
  ui: {
    colors: {
      primary: 'ocean',
      neutral: 'gray'
    },

    badge: {
      variants: { color: { success: 'dark:bg-lime-400/10 dark:text-lime-400' } }
    },

    button: {
      slots: {
        base: 'font-normal'
      },
      variants: {
        size: {
          xs: { base: 'px-2.5 py-1.5' },
          md: {
            base: 'py-2 px-3',
            trailingIcon: 'w-4 h-4',
            leadingIcon: 'h-4 w-4'
          }
        }
      },
      compoundVariants: [
        {
          color: 'info',
          variant: 'solid',
          class: 'bg-sky-400 hover:bg-sky-500'
        },
        {
          color: 'info',
          variant: 'outline',
          class: 'ring-sky-400 text-sky-400 hover:bg-sky-400/10'
        },
        {
          color: 'info',
          variant: 'ghost',
          class: 'text-sky-400 hover:bg-sky-950 '
        },
        {
          color: 'info',
          variant: 'soft',
          class: 'text-sky-400 bg-sky-950 hover:bg-sky-900'
        }
      ]
    },

    card: {
      slots: {
        root: 'dark:bg-midnight-700 dark:ring-midnight-600'
      }
    },

    commandPalette: {
      slots: {
        itemTrailingIcon: 'w-4 h-4',
        content: 'border-t dark:border-midnight-600',
        empty: 'py-10 sm:px-10 dark:text-uiGray-600',
        item: 'dark:text-uiPrimary-100 font-medium p-2',
        input:
          'm-2 dark:text-neutral-200 dark:placeholder:text-uiGray-600 border dark:border-uiGray-600 rounded-lg p-1 [&>input]:h-auto [&>input]:ps-8 [&_.iconify]:size-4 [&_.iconify]:text-uiGray-600'
      }
    },

    selectMenu: {
      slots: {
        group: 'cursor-pointer',
        item: 'items-center! hover:bg-midnight rounded-sm',
        content: 'z-50 dark:bg-midnight-700 dark:ring-midnight-600',
        trailingIcon:
          'group-data-[state=open]:rotate-180 transition-transform duration-200'
      },
      variants: {
        variant: {
          outline:
            'ring-1 dark:ring-midnight-600 shadow-md dark:bg-midnight-700 dark:text-neutral-400'
        },
        size: {
          md: {
            label: 'text-sm',
            itemTrailingIcon: 'w-4 h-4 -mt-0.5'
          }
        }
      }
    },

    tooltip: {
      slots: {
        text: 'whitespace-normal',
        content: 'p-2 h-auto text-left dark:bg-neutral-900/90 text-white'
      }
    },

    tabs: {
      slots: { root: 'gap-0' },
      variants: {
        variant: {
          pill: {
            indicator: 'dark:bg-midnight-700',
            trigger: 'data-[state=active]:dark:text-white'
          }
        }
      }
    },

    table: {
      slots: {
        thead: 'rounded-xs',
        separator: 'hidden',
        td: 'text-xs p-4 max-lg:px-2 text-uiPrimary-100',
        th: 'text-xs font-normal text-uiPrimary-100 p-2 lg:px-4 whitespace-nowrap dark:bg-midnight-700 first:rounded-tl-1 first:rounded-bl-1 last:rounded-tr-1 last:rounded-br-1'
      }
    },

    popover: {
      slots: { content: 'dark:bg-midnight-700 dark:ring-midnight-600' }
    }
  }
})
